var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52311 6.28379C7.52311 5.6482 8.01763 5.15369 8.65322 5.15369H19.8701C20.5056 5.15369 21.0002 5.64821 21.0002 6.28379V13.0083C21.0002 13.6439 20.5056 14.1384 19.8701 14.1384H19.2032V17.5076H18.754H18.7119L17.6941 16.4969C17.6943 16.4962 17.6943 16.4955 17.6943 16.4948C17.6942 16.493 17.6935 16.4911 17.6941 16.4899C17.7951 16.2497 17.8555 15.9865 17.8555 15.7107V8.52295C17.8555 7.41078 16.9461 6.50139 15.834 6.50139H7.52311V6.28379ZM3.03076 8.52295C3.03076 7.89299 3.52389 7.39986 4.15385 7.39986H15.834C16.4639 7.39986 16.957 7.89299 16.957 8.52295V15.7107C16.957 16.3407 16.4639 16.8338 15.834 16.8338H8.87082C8.75204 16.8347 8.63847 16.8827 8.55495 16.9672L5.31905 20.2031H5.27694H4.8277V16.8338H4.15385C3.52389 16.8338 3.03076 16.3407 3.03076 15.7107V8.52295Z",
    fill: "#717F8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessaging);
export default __webpack_public_path__ + "static/media/messaging.be315b79e3305defe182a54906745614.svg";
export { ForwardRef as ReactComponent };